module.exports = "/_next/static/images/app-store-4191bb396367b70c345c56fa3dfeeb8a.png.webp";